import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NodeEntityModels, PageEntityModels } from '@medsurf/flat-models';
import { AppSharedFacade, NavigationControlFacade, NodeSharedFacade } from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-sidebar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent {

  @Input() public showCurrentSubject: boolean;

  @Output() public chapterSelected = new EventEmitter<NodeEntityModels.ChapterNode>();
  @Output() public blockSelected = new EventEmitter<NodeEntityModels.BlockNode>();
  @Output() public specialPageSelected = new EventEmitter<string>();

  public constructor(public navigationControlFacade: NavigationControlFacade,
                     public appSharedFacade: AppSharedFacade,
                     public nodeSharedFacade: NodeSharedFacade) {
  }

  public quizNavChaptersFiltering(page: PageEntityModels.PageEntityType, quizNavSelection: boolean) {
    if (!quizNavSelection) return true;
    return page.type === 'QuizStart';
  }
}
